(function () {
  function setPanelState(item, open) {
    var button = item.querySelector('[data-sevenvn-faq-button]');
    var panel = item.querySelector('[data-sevenvn-faq-panel]');
    if (!button || !panel) return;

    item.classList.toggle('open', open);
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
  }

  function initFAQ(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-sevenvn-faq]');

    sections.forEach(function (section) {
      if (section.dataset.sevenvnFaqReady === 'true') return;
      section.dataset.sevenvnFaqReady = 'true';

      var items = Array.prototype.slice.call(section.querySelectorAll('.sevenvn-accordion'));
      var opened = false;

      items.forEach(function (item) {
        var button = item.querySelector('[data-sevenvn-faq-button]');
        if (!button) return;

        var defaultOpen = item.classList.contains('open') && !opened;
        if (item.classList.contains('open') && opened) item.classList.remove('open');
        setPanelState(item, defaultOpen);
        if (defaultOpen) opened = true;

        button.addEventListener('click', function () {
          var willOpen = !item.classList.contains('open');
          items.forEach(function (other) {
            setPanelState(other, other === item ? willOpen : false);
          });
        });
      });

      window.addEventListener('resize', function () {
        items.forEach(function (item) {
          if (item.classList.contains('open')) setPanelState(item, true);
        });
      });

      if (section.dataset.revealEnabled === 'true' && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            section.classList.add('is-visible');
            observer.disconnect();
          });
        }, { threshold: 0.16 });
        observer.observe(section);
      } else {
        section.classList.add('is-visible');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFAQ(document); });
  } else {
    initFAQ(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFAQ(event.target);
  });
})();
